import React from 'react';
import { Redirect } from 'react-router-dom';
import { FeatureFlag } from '__types__';
import { Loading } from 'v1/components/shared';
import { hasFlag } from 'lib/restrictedAccess';
import { useScopedFeatureFlagNames } from 'lib/restrictedAccess/useScopedFeatureFlagNames';

type PrivateRouteFeatureGateProps = {
  flag: FeatureFlag;
  children: React.ReactNode;
};

/**
 * Must render under AppScope (RouteAppScopeProvider or GlobalAppScopeProvider).
 * Pending flag set → Loading; missing flag → /unauthorized.
 */
export function PrivateRouteFeatureGate({
  flag,
  children
}: PrivateRouteFeatureGateProps) {
  const activeFeatureFlags = useScopedFeatureFlagNames();

  if (activeFeatureFlags == null) {
    return <Loading className="pageCenter" />;
  }

  if (!hasFlag(activeFeatureFlags, flag)) {
    console.log(`browsing scope does not have feature flag: ${flag}`);
    return <Redirect to="/unauthorized" />;
  }

  return <>{children}</>;
}
